import { DashboardMetricCard } from './PremiumDesign';
import { useNavigate } from 'react-router-dom';

import overviewContact from '../assets/overview_contact.png';
import overviewTemplate from '../assets/overview_template.png';
import overviewCampaign from '../assets/overview_campign.png';
import overviewIntegration from '../assets/overview_integration.png';
import { useDelayedSkeleton } from '@/common/hooks/useDelayedSkeleton';
import { SkeletonText } from '@/components';
import { useFormatters } from '../hooks/useFormatters';

export default function Metrics({ stats, isLoading, isFetching }) {
  const { formatNumber } = useFormatters();

  const navigate = useNavigate();
  const showDelayedSkeleton = useDelayedSkeleton(
    Boolean(isFetching && stats !== undefined),
    300,
    500,
  );
  const showSkeleton = isLoading || !stats || showDelayedSkeleton;

  const cards = [
    {
      title: 'Contacts',
      value: formatNumber(stats?.total_clients),
      iconSrc: overviewContact,
      iconBg: 'bg-[#F2F9FF] text-[#0088FF]',
      accent: '#0088FF',
      path: '/contacts',
    },
    {
      title: 'Templates',
      value: formatNumber(stats?.total_templates),
      iconSrc: overviewTemplate,
      iconBg: 'bg-[#FAF6E6] text-[#EEB90B]',
      accent: '#EEB90B',
      path: '/templates',
    },
    {
      title: 'Campaigns',
      value: formatNumber(stats?.total_campaigns),
      iconSrc: overviewCampaign,
      iconBg: 'bg-[#EBF4EA] text-[#50AB3D]',
      accent: '#50AB3D',
      path: '/campaigns',
    },
    {
      title: 'Integrations',
      value: formatNumber(stats?.total_connected_integrations),
      iconSrc: overviewIntegration,
      iconBg: 'bg-[#FAEBFC] text-[#CB30E0]',
      accent: '#CB30E0',
      path: '/integrations',
    },
  ];

  if (showSkeleton) {
    return (
      <div className="grid grid-cols-2 gap-3 font-sf-pro-display lg:grid-cols-4">
        {cards.map((card) => (
          <div
            key={card.title}
            className="relative flex min-h-[64px] w-full flex-row items-center gap-2 overflow-hidden rounded-[12px] bg-white py-2.5 pl-3.5 pr-2.5 text-left shadow-[0_1px_3px_rgba(0,0,0,0.06)] sm:min-h-[88px] sm:gap-3 sm:px-4 sm:py-3 laptop:!min-h-[84px] laptop:!gap-2 laptop:!py-2"
          >
            <span
              className="absolute bottom-2.5 left-0 top-2.5 w-[4px] rounded-r-full sm:bottom-3 sm:top-3"
              style={{ backgroundColor: card.accent }}
            />
            <span
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-[10px] sm:h-12 sm:w-12 laptop:!h-9 laptop:!w-9 ${card.iconBg}`}
            >
              <div className="h-4 w-4 sm:h-6 sm:w-6 rounded-md bg-skeleton-base animate-pulse" />
            </span>
            <div className="flex min-w-0 flex-1 flex-col gap-1.5">
              <SkeletonText width="w-20 sm:w-24" height="h-3.5 sm:h-4" />
              <SkeletonText width="w-10 sm:w-14" height="h-5 sm:h-6" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 font-sf-pro-display lg:grid-cols-4">
      {cards.map((card) => (
        <DashboardMetricCard
          key={card.title}
          title={card.title}
          value={card.value}
          icon={card.icon}
          iconSrc={card.iconSrc}
          iconBg={card.iconBg}
          accent={card.accent}
          onClick={card.path ? () => navigate(card.path) : undefined}
        />
      ))}
    </div>
  );
}
